export interface NavigationItem {
  label: string;
  icon: string;
  route?: string;
  links?: NavigationItem[];
  niveis?: readonly number[];
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { label: 'Home', icon: 'home', route: '/home' },
  { label: 'Dashboards', icon: 'bar-chart', route: '/dashboards' },
  {
    label: 'Cadastros',
    icon: 'team',
    links: [
      {
        label: 'Campanha',
        icon: 'unordered-list',
        links: [
          { label: 'Criar Campanha', icon: 'plus', route: '/campanhas/cadastro' },
          { label: 'Listar Campanha', icon: 'unordered-list', route: '/campanhas/listagem' },
          { label: 'Buscar Campanha', icon: 'search', route: '/campanhas/busca' }
        ]
      }
    ]
  },
  {
    label: 'RC/IC',
    icon: 'file-text',
    links: [
      { label: 'Listagem de RC', icon: 'unordered-list', route: '/rcs/listagem' },
      { label: 'Consultar RC', icon: 'search', route: '/rcs/consulta' },
      { label: 'Cadastro de RC', icon: 'plus', route: '/rcs/cadastro', niveis: [1, 2, 3] },
      { label: 'IC(s) Vigentes', icon: 'calendar', route: '/rcs/vigentes' }
    ]
  },
  {
    label: 'OIS',
    icon: 'file-text',
    links: [
      { label: 'Cadastrar', icon: 'plus', route: '/ois/cadastro', niveis: [1] },
      { label: 'Procurar', icon: 'search', route: '/ois/consulta' },
      { label: 'Listar', icon: 'unordered-list', route: '/ois/listagem' },
      { label: 'Listar Pré OIS', icon: 'unordered-list', route: '/pre-ois/listagem' },
      { label: 'Procurar Pre-OIS', icon: 'search', route: '/pre-ois/consulta' },
      { label: 'Relatórios OIS', icon: 'unordered-list', route: '/relatorios-ois/menu' }
    ]
  },
  {
    label: 'AP/AV/PI',
    icon: 'file-text',
    links: [
      { label: 'Cadastrar AP/AV', icon: 'plus', route: '/autorizacoes/busca-ois' },
      { label: 'Procurar', icon: 'search', route: '/autorizacoes/pesquisa' },
      { label: 'Listar AP', icon: 'unordered-list', route: '/autorizacoes/listagem-ap' },
      { label: 'Listar AV', icon: 'unordered-list', route: '/autorizacoes/listagem-av' },
      { label: 'Listar PI', icon: 'unordered-list', route: '/pedidos-insercao/listagem' },
      { label: 'Relatório', icon: 'unordered-list', route: '/relatorios-ap' },
      {
        label: 'Importação',
        icon: 'file-text',
        links: [
          { label: 'Carregar Arquivos', icon: 'plus', route: '/importacao-ap-pi/carga' },
          { label: 'Arquivos Pendentes', icon: 'unordered-list', route: '/importacao-ap-pi/passo-1' },
          { label: 'Arquivos Ativos', icon: 'unordered-list', route: '/importacao-ap-pi/passo-2' }
        ]
      }
    ]
  },
  {
    label: 'SAC',
    icon: 'file-text',
    links: [
      { label: 'Cadastrar', icon: 'plus', route: '/sacs/cadastro', niveis: [1, 2, 3] },
      { label: 'Procurar', icon: 'search', route: '/sacs/consulta' },
      { label: 'Listar', icon: 'unordered-list', route: '/sacs/listagem' },
      { label: 'Relatório', icon: 'unordered-list', route: '/relatorios-sac' }
    ]
  },
  {
    label: 'Empresas',
    icon: 'shop',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/empresas/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/empresas/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/empresas/consulta' },
      { label: 'Relatório', icon: 'unordered-list', route: '/relatorios-empresa' },
      { label: 'Agência', icon: 'unordered-list', route: '/vinculos-empresas/agencias' },
      { label: 'Fornecedor', icon: 'unordered-list', route: '/vinculos-empresas/fornecedores' },
      {
        label: 'Veículo',
        icon: 'unordered-list',
        links: [
          { label: 'Procurar', icon: 'search', route: '/veiculos/consulta' },
          { label: 'Listar', icon: 'unordered-list', route: '/veiculos/listagem' }
        ]
      }
    ]
  },
  {
    label: 'Funcionários',
    icon: 'user',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/funcionarios/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/funcionarios/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/funcionarios/pesquisa' },
      { label: 'Relatório', icon: 'unordered-list', route: '/relatorios-funcionario/catalogo' },
      {
        label: 'Gerente',
        icon: 'user',
        niveis: [1],
        links: [
          { label: 'Listagem', icon: 'unordered-list', route: '/gerentes/listagem' },
          { label: 'Cadastrar', icon: 'plus', route: '/gerentes/cadastro' },
          { label: 'Consultar', icon: 'search', route: '/gerentes/busca' }
        ]
      }
    ]
  },
  {
    label: 'Unidades',
    icon: 'apartment',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/unidades/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/unidades/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/unidades/consulta' }
    ]
  },
  {
    label: 'Contas Despesa',
    icon: 'wallet',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/contas-despesa/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/contas-despesa/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/contas-despesa/consulta' }
    ]
  },
  {
    label: 'Cidades',
    icon: 'environment',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/cidades/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/cidades/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/cidades/consulta' }
    ]
  },
  {
    label: 'Grupos Empresariais',
    icon: 'cluster',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/grupos-empresariais/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/grupos-empresariais/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/grupos-empresariais/consulta' }
    ]
  },
  {
    label: 'Categorias',
    icon: 'tags',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/categorias/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/categorias/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/categorias/consulta' }
    ]
  },
  {
    label: 'Títulos',
    icon: 'font-size',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/titulos/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/titulos/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/titulos/consulta' }
    ]
  },
  {
    label: 'Peças',
    icon: 'picture',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/pecas/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/pecas/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/pecas/consulta' }
    ]
  },
  {
    label: 'Produtos',
    icon: 'appstore',
    links: [
      { label: 'Listagem', icon: 'unordered-list', route: '/produtos/listagem' },
      { label: 'Cadastrar', icon: 'plus', route: '/produtos/cadastro' },
      { label: 'Consultar', icon: 'search', route: '/produtos/consulta' }
    ]
  },
  {
    label: 'SP',
    icon: 'file-text',
    links: [
      { label: 'Cadastrar SP', icon: 'plus', route: '/sps/cadastro' },
      { label: 'Procurar SP Agência', icon: 'search', route: '/sp-agencia/consulta' },
      { label: 'Procurar SP Sem Agência', icon: 'search', route: '/sps/consulta' },
      { label: 'Visualizar SP Agência', icon: 'unordered-list', route: '/sp-agencia/listagem' },
      { label: 'Visualizar SP Sem Agência', icon: 'unordered-list', route: '/sps/listagem' },
      { label: 'Relatório', icon: 'unordered-list', route: '/relatorios-sp' }
    ]
  },
  {
    label: 'PC',
    icon: 'file-text',
    links: [
      { label: 'Cadastrar', icon: 'plus', route: '/prestacoes-contas/cadastro' },
      { label: 'Procurar', icon: 'search', route: '/prestacoes-contas/consulta' },
      { label: 'Visualizar', icon: 'unordered-list', route: '/prestacoes-contas/listagem' },
      { label: 'Relatório', icon: 'unordered-list', route: '/relatorios-pc' }
    ]
  },
  {
    label: 'Administração',
    icon: 'user',
    route: '/usuarios',
    niveis: [1],
    links: [
      { label: 'Cadastrar', icon: 'plus', route: '/usuarios/cadastro' },
      { label: 'Procurar', icon: 'search', route: '/usuarios/pesquisa' },
      { label: 'Listar', icon: 'unordered-list', route: '/usuarios/listagem' }
    ]
  },
  { label: 'Minha Conta', icon: 'user', route: '/minha-conta' }
];
